/* eslint-disable func-names */
(function(algolia) {
  const { getAlgoliaResults } = algolia.externals;
  const { config, headerTemplate, collectionsTemplate } = algolia;
  const resource = 'collections';

  algolia.collectionsPlugin = {
    getSources({ query }) {
      return [
        {
          sourceId: resource,
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: `${config.index_prefix}${resource}`,
                  query,
                  params: {
                    hitsPerPage: config.collections_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled
                  },
                },
              ],
            });
          },
          templates: {
            header({ html, state }) {
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const itemLink = `${WYATT.routes.root}collections/${item.handle}`;
              return collectionsTemplate({ item, html, components }, itemLink);
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
